import { useState, useEffect, useRef } from 'react';
import Scrollbar from 'simplebar-react';
import { Link } from 'react-router-dom';
import AppMenuItem from './AppMenuItem';
import { sidebarConfig } from '../../Data/Sidebar/sidebar';
import { getUser } from '@/Services/localStorageUtility';

const AppSidebar = ({ collapsed, setCollapsed }) => {
  const user = getUser();
  const roleType = user?.roleData?.type;
  const firstName = user?.userData?.firstName || user?.userData?.username || 'User';
  const lastName = user?.userData?.lastName || '';
  const email = user?.userData?.email || '';
  const roleName = user?.roleData?.name || roleType || '';
  const initial = firstName.charAt(0).toUpperCase();

  const [showLogout, setShowLogout] = useState(false);
  const footerRef = useRef(null);

  useEffect(() => {
    if (!showLogout) return;
    const handler = (e) => {
      if (footerRef.current && !footerRef.current.contains(e.target)) {
        setShowLogout(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [showLogout]);

  const confirmLogout = () => {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('token');
    window.location.href = '/admin-pages/auth_pages/sign_in';
  };

  return (
    <>
      <aside className={`app-sidebar ${collapsed ? 'app-sidebar--collapsed' : ''}`}>

        {/* ── Header ── */}
        <div className="nsb-header">
          {!collapsed && (
            <Link to="/" className="nsb-logos">
              <img src="/assets/images/logo/header-logo.png" alt="logo" className="nsb-brand-logo" />
              <span className="nsb-brand-name">ATLAS</span>
            </Link>
          )}
          <button
            className="app-sidebar__toggle"
            onClick={() => setCollapsed((v) => !v)}
            title={collapsed ? 'Expand' : 'Collapse'}
          >
            <i className="ti ti-menu-2" />
          </button>
        </div>

        {/* ── Nav ── */}
        <Scrollbar className="app-sidebar__scroll">
          <ul className="app-sidebar__nav">
            {sidebarConfig.map((config, i) => {
              const hasPermission = config.permission ? user?.userData?.[config.permission] : true;
              return config.roles.includes(roleType) && hasPermission ? (
                <AppMenuItem key={i} {...config} roleType={roleType} collapsed={collapsed} />
              ) : null;
            })}
          </ul>
        </Scrollbar>

        {/* ── Footer: User + Popover ── */}
        <div className="app-sidebar__footer" ref={footerRef}>

          {showLogout && (
            // collapsed ? (
            //   <button className="app-sidebar__logout-btn" onClick={confirmLogout} title="Logout">
            //     <i className="ti ti-logout" />
            //   </button>
            // ) : (
            <div className="app-sidebar__user-card">
              <div className="app-sidebar__uc-meta">
                {roleName && (
                  <div className="app-sidebar__uc-row">
                    <i className="ti ti-shield-check" />
                    <span title={roleName}>{roleName}</span>
                  </div>
                )}
                {email && (
                  <div className="app-sidebar__uc-row">
                    <i className="ti ti-mail" />
                    <span title={email}>{email}</span>
                  </div>
                )}
              </div>

              <button className="app-sidebar__uc-logout" onClick={confirmLogout}>
                <i className="ti ti-logout" />
                <span>Logout</span>
              </button>
            </div>
            // )
          )}

          <div className="app-sidebar__user" onClick={() => setShowLogout((v) => !v)} title="Account">
            <div className="app-sidebar__avatar">{initial}</div>
            {!collapsed && (
              <div className="app-sidebar__user-info">
                <span className="app-sidebar__user-name">{firstName} {lastName}</span>
                {/* <span className="app-sidebar__user-role">{roleName}</span> */}
              </div>
            )}
          </div>

        </div>

      </aside>
    </>
  );
};

export default AppSidebar;
